// Copyright ©️ 2026 eVolve MEP, LLC

import { Button, Stack, Text } from '@mantine/core';

import { isNil, isNotNil } from 'helpers/isNotNil';
import { BendDimensionInputs } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/BendDimensionInputs';
import { useBendCreatorFormContext } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/useBendCreatorFormContext';
import { BEND_TYPE_STEP } from 'modules/Shop/EvolveFabrication/BendCreator/Nav/bendCreatorSteps';
import { BenderPicker } from 'modules/Shop/EvolveFabrication/BendCreator/Nav/steps/BenderPicker';
import { useBendBuilder } from 'modules/Shop/EvolveFabrication/BendCreator/State/useBendBuilder';

export const DimensionsStep = () => {
  const {
    values: { bendType },
    errors,
  } = useBendCreatorFormContext();
  const { openStep } = useBendBuilder();

  if (isNil(bendType)) {
    return (
      <Stack gap="sm" align="flex-start">
        <Text>Pick a bend type first.</Text>
        <Button variant="default" onClick={() => openStep(BEND_TYPE_STEP)}>
          Pick a bend type
        </Button>
      </Stack>
    );
  }

  return (
    <Stack gap={20}>
      <BendDimensionInputs offerCenterBend />
      {/* Validation errors that belong to no single field are kept on the bend type. */}
      {isNotNil(errors.bendType) && (
        <Text c="red" fz="sm">
          {errors.bendType}
        </Text>
      )}
      <BenderPicker />
    </Stack>
  );
};
